export default "__VITE_ASSET__08c5ff8d__"